var _circle, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgT4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 214,
    viewBox: "0 0 214 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 106.5,
    r: 55.5,
    fill: "#4F4F4F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_62_27)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 107,
    r: 75,
    fill: "#767676",
    fillOpacity: 0.34
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.417 125.375H111.583C111.583 128.171 109.296 130.458 106.5 130.458C103.704 130.458 101.417 128.171 101.417 125.375ZM129.375 120.292V122.833H83.625V120.292L88.7083 115.208V99.9583C88.7083 92.0791 93.7917 85.2166 101.417 82.9291V82.1666C101.417 79.3708 103.704 77.0833 106.5 77.0833C109.296 77.0833 111.583 79.3708 111.583 82.1666V82.9291C119.208 85.2166 124.292 92.0791 124.292 99.9583V115.208L129.375 120.292ZM119.208 99.9583C119.208 92.8416 113.617 87.2499 106.5 87.2499C99.3833 87.2499 93.7917 92.8416 93.7917 99.9583V117.75H119.208V99.9583Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_62_27",
    x: 0.6,
    y: 0.6,
    width: 212.8,
    height: 212.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.7,
    result: "effect1_foregroundBlur_62_27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT4);
export default __webpack_public_path__ + "static/media/T4.3ed51a366a1df7b50c03d5ef46a892d0.svg";
export { ForwardRef as ReactComponent };